import classNames from 'classnames';
import logo from '../../../assets/images/logo.svg';

export default function Loading(props: {onlyLogo?: boolean}) {
  return (
    <div className={classNames({
      "d-flex flex-column justify-content-center align-items-center user-select-none": true,
      "vh-100": !props.onlyLogo
    })}>
      <div className='logo-loading'>
        <img src={logo} alt="Cypherleak" />
      </div>
    </div>
  );
}
